import JobRightDrawerContainer from "../../../components/job/other/JobRightDrawer";

const JobRightDrawer = () => {
  return <JobRightDrawerContainer />;
};

export default JobRightDrawer;
